import { gql } from '@apollo/client'

export const getActiveBrandingKey = gql`
  query {
    getActiveBrandingKey
  }
`

export const allBrandings = gql`
  query allBrandings {
    allBrandings {
      id
      displayName
      brandingKey
    }
  }
`
